// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1BwnG","assignButton":"CreateEditEquipmentSchedule_assignButton__2peVI"};